export const LANGUAGE_DEFAULT_VALUE = "default";

export const LANGUAGE_OVERRIDE_STORAGE_KEY = "translationLanguageOverride";

export const TRANSLATION_CACHE_VERSION = "dynamic-translation-graphql-v1";

export const TRANSLATION_FIELD_TYPES = {
    comment        : "comment",
    jobDescription : "job_description"
};

const isDisabledEnvValue = (value) => String(value || "").toLowerCase() === "false";

const getPositiveNumberEnv = (value, fallback) => {
    const number = Number(value);

    return Number.isFinite(number) && number > 0 ? number : fallback;
};

export const AI_TRANSLATION_ENABLED = !isDisabledEnvValue(
    process.env.REACT_APP_TRANSLATION_AI_ENABLED ||
    process.env.TRANSLATION_AI_ENABLED
);

export const AI_TRANSLATION_GRAPHQL_TIMEOUT_MS = getPositiveNumberEnv(
    process.env.REACT_APP_TRANSLATION_GRAPHQL_TIMEOUT_MS ||
    process.env.TRANSLATION_GRAPHQL_TIMEOUT_MS,
    180000
);

export const TRANSLATION_LIMITS = {
    maxTextChars          : 1200,
    maxBatchChars         : 20000,
    maxBatchItems         : 350
};

export const TRANSLATION_LANGUAGES = [
    {
        slug         : "en",
        label        : "English",
        short        : "EN",
        displayShort : "EN"
    },
    {
        slug         : "de",
        label        : "Deutsch",
        short        : "DE",
        displayShort : "DE"
    },
    {
        slug         : "uk",
        label        : "Ukrainian",
        short        : "UK",
        displayShort : "UA"
    },
    {
        slug         : "cs",
        label        : "Czech",
        short        : "CS",
        displayShort : "CS"
    },
    {
        slug         : "pl",
        label        : "Polish",
        short        : "PL",
        displayShort : "PL"
    },
    {
        slug         : "sk",
        label        : "Slovak",
        short        : "SK",
        displayShort : "SK"
    },
    {
        slug         : "fr",
        label        : "French",
        short        : "FR",
        displayShort : "FR"
    },
    {
        slug         : "ro",
        label        : "Romanian",
        short        : "RO",
        displayShort : "RO"
    }
];

export const getLanguage = (slug) => {
    return TRANSLATION_LANGUAGES.find((language) => language.slug === slug);
};

const getBackendLanguage = (slug, languages = []) => {
    if (!slug || !Array.isArray(languages)) return null;

    return languages.find((language) => language && language.slug === slug) || null;
};

export const isLanguageEnabled = (slug, languages = []) => {
    const language = getLanguage(slug);

    if (!language) return false;

    const backendLanguage = getBackendLanguage(slug, languages);

    return backendLanguage ? backendLanguage.status !== false : true;
};

export const getEnabledLanguage = (slug, languages = []) => {
    return isLanguageEnabled(slug, languages) ? getLanguage(slug) : null;
};

export const getTranslationLanguagesWithStatus = (languages = []) => (
    TRANSLATION_LANGUAGES.map((language) => {
        const backendLanguage = getBackendLanguage(language.slug, languages);

        return {
            ...language,
            status: backendLanguage ? backendLanguage.status !== false : true
        };
    })
);
